import './FounderPreview.scss';

import { Link } from 'react-router-dom';

// same file the /founder page uses — served out of public/ rather than
// imported through the bundler, which is where it was dropped
const portrait = `${process.env.PUBLIC_URL}/team/John_G.jpg`;

// The home page stays company-first, but the founder is the reason anyone
// trusts a one-person shop with their story — so it gets a real block here
// with a portrait and a taste of the bio, and the full page is one click away.
// Copy stays deliberately broad: parish, nonprofit, and wedding visitors all
// land on this page. The church-centric telling lives on /founder.
function FounderPreview() {
    return (
        <div className="FounderPreview">
            <div className="FounderPreview-portrait reveal">
                <img src={portrait} alt="Johnathan Geiger, founder of Candlelyte Productions"
                    loading="lazy" decoding="async" />
            </div>

            <div className="FounderPreview-container reveal delay-1">
                <span className="FounderPreview-eyebrow">Meet the founder</span>
                <h2>Johnathan <b>Geiger</b></h2>
                <p className="FounderPreview-role">Founder &middot; Director &middot; Cinematographer &middot; Editor</p>

                <p>There are people and organizations everywhere doing extraordinary work
                that almost nobody hears about. Not for lack of a story — telling one well is
                simply its own craft. That gap is why Candlelyte exists.</p>

                {/* third person here and on /founder — the site speaks as Candlelyte,
                    not as Johnathan */}
                <p>Whatever the project is, the part Johnathan cares most about is getting the
                message right: what actually needs to be said, and who it needs to reach.
                Everything after that is craft in service of the answer.</p>

                <Link to="/founder" className="FounderPreview-more">
                    <span>See more</span>
                    <i aria-hidden="true">&rarr;</i>
                </Link>
            </div>
        </div>
    );
}

export default FounderPreview;
